import axios from 'axios'

export const state = {
  duties: null,
}

export const getters = {
  duties: (state) => state.duties,
}

export const mutations = {
  SET_DUTIES(state, duties) {
    state.duties = duties
  },
}

export const actions = {
  fetchAllDuties({ commit, state, rootState }, payload) {
    return axios
      .get('/api/duties', {
        params: payload,
      })
      .then((response) => {
        const duties = response.data
        commit('SET_DUTIES', duties)
        return duties
      })
  },

  createDuty({ commit, state, rootState }, payload) {
    return axios.post('/api/duties', payload)
  },

  updateDuty({ commit, state, rootState }, payload) {
    return axios.put(`/api/duties/${payload.id}`, payload)
  },

  deleteDuty({ commit, state, rootState }, { id, reason }) {
    return axios.delete(`/api/duties/${id}`, { params: { id, reason } })
  },
}
